import { ClientError } from 'graphql-request';

const env = import.meta.env;

const REST_API_NAMESPACE = '/api/v1';

export class ConfigService {
  static get SNOWPLOW_APPID(): string {
    return env.VITE_SNOWPLOW_APPID;
  }

  static get SNOWPLOW_CONNECTOR(): string {
    return env.VITE_SNOWPLOW_CONNECTOR;
  }

  static get BACKEND_GRAPHQL_ENDPOINT(): string {
    return `${env.VITE_BACKEND_URL}/graphql`;
  }

  static get BACKEND_REST_ENDPOINT(): string {
    return `${env.VITE_BACKEND_URL}${REST_API_NAMESPACE}`;
  }

  static get OKTA_DOMAIN(): string {
    return env.VITE_OKTA_DOMAIN;
  }

  static get OKTA_CLIENT_ID(): string {
    return env.VITE_OKTA_CLIENT_ID;
  }

  static get OKTA_REDIRECT(): string {
    return env.VITE_OKTA_REDIRECT;
  }

  static get OKTA_CLIENT_SECRET(): string {
    return env.VITE_OKTA_CLIENT_SECRET;
  }

  static get PROXY_URL(): string {
    return `${env.VITE_BACKEND_URL}${REST_API_NAMESPACE}/proxy`;
  }

  /**
   * PhotoVogue module — serve mock data instead of calling `photovogue-api`.
   * Step 1 (UI on mocks): set `VITE_PHOTOVOGUE_USE_MOCKS=true`.
   * Step 2 (real API): unset/`false` to route through the HTTP service.
   */
  static get PHOTOVOGUE_USE_MOCKS(): boolean {
    return env.VITE_PHOTOVOGUE_USE_MOCKS === 'true';
  }

  /** Direct `photovogue-api` origin. That API verifies the staff Okta token. */
  static get PHOTOVOGUE_API_ENDPOINT(): string {
    const endpoint = env.VITE_PHOTOVOGUE_API_URL;
    if (!endpoint) {
      throw new Error('VITE_PHOTOVOGUE_API_URL is not configured');
    }
    return endpoint.replace(/\/$/, '');
  }

  static get PHOTOVOGUE_GRAPHQL_ENDPOINT(): string {
    return `${this.PHOTOVOGUE_API_ENDPOINT}/graphql`;
  }

  static get PHOTOVOGUE_REST_ENDPOINT(): string {
    return this.PHOTOVOGUE_API_ENDPOINT;
  }

  static get isLocalEnv(): boolean {
    return (
      env.VITE_NODE_ENV === 'staging' || env.VITE_NODE_ENV === 'development'
    );
  }
}

export function extractErrorFromResponse(error: unknown) {
  if (error instanceof ClientError) {
    const err = error as ClientError;
    if (err.response.errors && err.response.errors.length) {
      const firstError = err.response.errors[0] as unknown as {
        code: number;
        message: string;
      };
      return firstError;
    }
  }
  console.error('Unexpected error format', error);
  return null;
}
